
let other = {
    noReason: '暂无理由',
    /* 佣金历史 */
    total: '总笔数',
    commissionTotal: '佣金总额',
    IBAccount: 'IB账号数',
    tradingAccount: '交易账号数',
    transactionNumber: '交易手数',
    confirmDeductions: '是否确认扣款',
    confirmTransfer: '是否确认转账？',
    selectGroup: '请选择组别',
    selectType: '请选择类别',
    selectDatetime: '选择日期',
    addRebate: '添加佣金信息',
    /* placeholder */
    enterTicket: '请输入订单号',
    enterAccount: '请输入代理账号',
    enterLogin: '请输入账号',
    enterSymbol: '请输入品种',
    selectClientGroup: '请选择客户组别',
    selectCMD: '请选择类型',
    enterVolume: '请输入交易手数',
    selectOpentime: '请选择开仓时间',
    selectClosetime: '请选择平仓时间',
    selectRightDate: '请选择正确的时间',
    enterProfit: '请输入佣金',
    /* 导入导出表格 */
    selectExportType: '选择导出表类型',
    importExcel: '导入',
    exportExcel: '导出',
    selectDate: '请选择时间',
    /* 银行卡审核 */
    bankcardCheck: '银行卡审核',
    sureEditCharge: '确定修改手续费？',
    updateTime: '完成时间',
    firstWithdraw: '第一次出金',
    isWithdrawed: '本月已出金',
    time: '次',
    checked: '已验证',
    noChecked: '未验证',
    refused: '已拒绝',
    plus: '正',
    minus: '负',
    confirmBankcardInfo: '确认出金银行卡信息？',
    confirmRefuse: '确认拒绝？',
    confirmSuccess: '确认成功',
    transferSuccess: '转账申请成功',
    haveEditPwd: '用户已更改密码',
    editUserGroupSuccess: '修改用户组成功',
    editUserGroupFailed: '修改用户组失败',
    /* 账单 */
    billAccount: '代理账号',
    billLogin: '交易账号',
    billOrder: '订单号',
    billType: '类型',
    billLoss: '盈亏',
    billTime: '创建时间',
    warm_prompt: '温馨提示：',
    gold: '① 当月第一笔银联出金免费,再次申请银联出金则每次收取（<span class="chargeNumber">$&nbsp;10</span>）手续费；',
    estimated: '② 本次出金预计手续费：<span class="chargeNumber">$&nbsp;{price}</span><span style="font-size: 12px;">（仅供参考）</span>。',
    bank_country: '银行所在国家',
    enterBankCountry: '输入银行所在国家',
    formatError: '格式不正确',
    other_cn: 'CN（中文）',
    other_login: '登录',
    other_en: 'EN（英文）',
    other_ae: 'AR（阿拉伯文）',
    activeAccounts: '活躍賬戶',
    inactiveAccounts: '無效帳戶',
    other_footer: ' © 2022 Copyright all rights reserved',

}

export default other;




































// WEBPACK FOOTER //
// ./src/i18n/chinese/other.js